import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g data-name="Group 9039" transform="translate(-90 -306)">
        <circle
          data-name="Ellipse 893"
          cx="15"
          cy="15"
          r="15"
          transform="translate(90 306)"
          style={{ fill: '#001762' }}
        />
        <g transform="translate(97.643 313.28)">
          <circle
            data-name="Ellipse 387"
            cx="3.63"
            cy="3.63"
            r="3.63"
            transform="translate(2.685)"
            style={{ fill: '#fff' }}
          />
          <path
            data-name="Path 1350"
            d="M3.394 24.038h5.742c-1.692-1.576-2.586-4.39-1.375-6.48-1.2-.069-1.808-.682-2.634-1.7A6.036 6.036 0 0 0 2 21.337v1.08a1.525 1.525 0 0 0 1.394 1.621z"
            transform="translate(-2 -8.6)"
            style={{ fill: '#fff' }}
          />
        </g>
        <circle
          data-name="Ellipse 875"
          cx="4.292"
          cy="4.292"
          transform="translate(103.774 320.08)"
          style={{ fill: '#fff' }}
          r="4.292"
        />
        <path
          data-name="Line 634"
          transform="translate(106.193 322.5)"
          style={{ fill: 'none', stroke: '#001762' }}
          d="m0 0 4.05 4.05"
        />
        <path
          data-name="Line 635"
          transform="translate(106.193 322.5)"
          style={{ fill: 'none', stroke: '#001762' }}
          d="M4.05 0 0 4.05"
        />
      </g>{' '}
    </svg>
  )
}

type InValidUserProps = SvgIconProps

export const InValidUser: React.FC<InValidUserProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 30 30" focusable="false" aria-hidden="true" />
}
